<template>
    <div id="Console">
        <!-- <list
            label3="未确认"
            @refresh="refresh"
            @clickMag="affirm"
            :tableData3="tableData3"
        ></list> -->
        <el-card shadow="never">
            <el-row>
                <el-col :span="16">
                    <el-button-group>
                        <el-button type="info" @click="refreshTypes2('G')" icon="el-icon-refresh">刷新</el-button>
                        <el-button @click="affirm()" type="info">确认</el-button>
                    </el-button-group>   
                </el-col>
                <el-col :span="6" class="serch-input" style="float:right;">
                    <el-input placeholder="请输入类型编号" v-model="input5" class="input-with-select" clearable>
                    </el-input>
                </el-col>  
            </el-row>  

            <el-row class="con-table">
                <el-col :span="24">
                    <el-table
                        v-loading="loading"
                        element-loading-text="努力加载中"
                        element-loading-spinner="el-icon-loading"
                        :data="tableData3.filter(data => !input5 || data.typeCode.includes(input5))"
                        tooltip-effect="dark"
                        style="width: 100%"
                        max-height="340"
                        border
                        :summary-method="getSummaries"
                        show-summary
                    >
                        <el-table-column
                            label="类型编号"
                            prop="typeCode"
                            width="120"
                            header-align="center"
                        >
                            <template slot-scope="scope">{{ scope.row.typeCode }}</template>
                        </el-table-column>
                        <el-table-column
                            prop="description"
                            label="类型名称"
                            header-align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="totalGeneratedQty"
                            label="已生成"
                            align="right"
                            header-align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="qty"
                            label="未确认"
                            align="right"
                            header-align="center"
                        >
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less" scoped>
    .el-table__footer-wrapper td{
        text-align: right !important;
    }
    .serch-input{
        float:right;
    }
    .select-state{
        margin-left: 10px;
    }
    .con-table{
        margin-top: 20px;
    }
</style>
<script>
import list from '@/components/list'
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
import { getToken } from '@/env/util'
export default {
    mixins:[requestMixin,common],
    components:{
        list
    },
    data(){
        return {
            tableData3: [
                {
                    typeCode: '',
                    description: '',
                    qty:'',
                    totalGeneratedQty:'',
                    creatDate: '',
                    createUser:''
                }
            ],
            value: '',
            input5:'',
            loading: false,
        }
    },
    mounted(){
        //如果没有Token跳转Login页面
        getToken();
        //刷新
        this.$nextTick(function () {
            this.refreshTypes2("G");
        })
    },
    methods:{
        //确认券
        affirm(){
            this.$router.push({
                path:'/ticket/manage',
                query:{
                    confirmQty : this.unAmount 
                }
            })
        },
        refresh(){
            this.refreshTypes2('G');
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总计';
                    return;
                }
                if (index === 1) {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item =>{
                    //(+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
                    return Number(item[column.property].toString().replace(/,/g, ""))
                });
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    // sums[index]
                    sums[index] = this.changeTree(sums[index]);
                } else {
                    sums[index] = '';
                }
                });
                return sums;
        },
    }
}
</script>
